import React from "react";

import WithdrawalErrorIcon from "../../../images/withdrawal_error.svg";
import { Button } from "../../atoms/button";
import { useTranslation } from "@repo/translation";
import { Text } from "../../atoms/text";
import { StyledTitle, StyledImageContainer} from "./style";

export const WithdrawStepSalaryInfo = () => {
  const { translate } = useTranslation();
  return (
    <>
      <section style={{margin: "auto"}}>
        <StyledImageContainer>
          <img src={WithdrawalErrorIcon} />
        </StyledImageContainer>
        <StyledTitle bold style={{ textAlign: "center" }}>
          {translate("payments.withdraw.salaryAccountInfo.title")}
        </StyledTitle>
        <Text style={{ textAlign: "center" }}>
          {translate("payments.withdraw.salaryAccountInfo.description")}
        </Text>
      </section>

      <Button expand className="btn-cta" type="button" href="/account/bank-accounts/">
        {translate("payments.withdraw.salaryAccountInfo.register")}
      </Button>
    </>
  );
};
